module.exports = __webpack_public_path__ + "static/img/logo_title.efc32f2b.png";